import { createReducer } from "reduxsauce";
import { DEFAULT_FINANCE_TYPE } from "../../../config/finance-config";
import Types from "./types";

export const INITIAL_STATE = {
    showInHouseFinance: {
        data: DEFAULT_FINANCE_TYPE.showInHouseVariant
    },
    showWarrantyPageShift: {
        data: null
    },
    showNonPreApprovedPayOptions: {
        data: null
    },
    showPremiumFeatures: {
        data: null
    },
    showUserDeliveryTimeline: {
        data: null
    },
    financeFirstCheckoutRevamp: {
        data: null
    },
    c2bMechanicalCondition: {
        data: "VARIANT_A"
    },
    statsigConfig: {
        initialized: false
    },
    c2bSellLandingMobileNumber: {
        data: null
    },
    servicingBundleRevamp: {
        data: null
    },
    webLocationHighlighting: {
        data: null
    },
    webPriceDropMsite: {
        data: null
    },
    webPriceDropDesktop: {
        data: null
    },
    desktopHubspotAssistance: {
        data: null
    },
    msiteRefurbVisibilityCdp: {
        data: null
    },
    msiteBi2ph: {
        data: null
    },
    galleryOnTheFlyDesktop: {
        data: null
    },
    msiteCdpEw: {
        data: null
    },
    webOrderSummaryVasGift: {
        data: null
    },
    msiteHubspotAssistance: {
        data: null
    },
    desktopCdpEw: {
        data: null
    },
    desktopCarCard: {
        data: null
    },
    desktopWishlistAdoption: {
        data: null,
        featureFlags: null
    },
    msiteWishlistAdoption: {
        data: null,
        featureFlags: {}
    },
    webCarTour: {
        data: null
    },
    desktopPremiumFeatures: {
        data: null
    },
    msitePremiumFeatures: {
        data: null
    },
    desktopHandoverCharges: {
        data: null
    },
    cdpCtaReorder: {
        data: null
    },
    msiteHandoverCharges: {
        data: null
    },
    msiteSinglePageTd: {
        data: null
    },

    desktopSortingVictoria: {
        data: null
    },
    desktopSortingNsw: {
        data: null
    },
    desktopSortingQueensland: {
        data: null
    },

    msiteSortingVictoria: {
        data: null
    },
    msiteSortingNsw: {
        data: null
    },
    msiteSortingQueensland: {
        data: null
    },
    stagingDealerBadge: {
        data: null
    },
    msiteLuxuryCars: {
        data: null
    },
    desktopLuxuryCars: {
        data: null
    },
    msiteChrWidget: {
        data: null
    },
    desktopChrWidget: {
        data: null
    },
    preApprovalOnFlyDesktop: {
        data: null
    },
    preApprovalOnFlyMsite: {
        data: null
    },
    hideImperfectionsMsite: {
        data: null
    },
    hideImperfectionsDesktop: {
        data: null
    },
    whatsappEnabled: {
        data: null
    },
    msiteVehicleBasePrice: {
        data: null
    },
    desktopVehicleBasePrice: {
        data: null
    },
    desktopStripeGateway: {
        data: null
    },
    msiteStripeGateway: {
        data: null
    }
};

export const setExperiment = (state = INITIAL_STATE, {
    experimentType, experimentData, flattened = false
}) => {
    return {
        ...state,
        ...(flattened ? { [experimentType]: experimentData } :
            {
                [experimentType]: {
                    data: experimentData
                }
            })
    };
};

export const setAllABExperiment = (state = INITIAL_STATE, { variants }) => {
    return {
        ...state,
        ...variants
    };
};

export const setStatsigInitialization = (state = INITIAL_STATE, { statsigInitialized }) => {
    return {
        ...state,
        statsigConfig: {
            initialized: statsigInitialized
        }
    };
};

export const allClearExperiment = () => {
    return {};
};

export const clearExperiment = ({ updatedExperiments }) => {
    return {
        updatedExperiments
    };
};

export const HANDLERS = {
    [Types.SET_EXPERIMENT]: setExperiment,
    [Types.SET_ALL_EXPERIMENT]: setAllABExperiment,
    [Types.SET_STATSIG_INITIALIZATION]: setStatsigInitialization,
    [Types.ALL_CLEAR_EXPERIMENT]: allClearExperiment,
    [Types.CLEAR_EXPERIMENT]: clearExperiment
};

export default createReducer(INITIAL_STATE, HANDLERS);
